import * as React from 'react';
import { ExportModel } from '../model/ExportModel';
import { ExportController } from '../controller/ExportController';
import { AScene } from '@eagerlogic/react-mvc';
import { ISceneFactory } from 'scenes/ISceneFactory';
import { HistoryItem } from 'utils/Navigation';
import { Paper } from 'components/paper';
import { Button } from '@material-ui/core';
import { MonthlyVacationExportPaper } from './MonthlyVacationExportPaper';

export class ExportScene extends AScene<Props, ExportModel, ExportController> {

    public constructor(props: Props) {
        super(props);

        this.handleGenerateApiKeyClicked = this.handleGenerateApiKeyClicked.bind(this);
        this.handleRevokeApiKeyClicked = this.handleRevokeApiKeyClicked.bind(this);
    }

    private handleGenerateApiKeyClicked() {
        this.controller.onGenerateApiKeyClicked();
    }

    private handleRevokeApiKeyClicked() {
        this.controller.onRevokeApiKeyClicked();
    }

    protected createControlller(): ExportController {
        return new ExportController();
    }

    public render(): React.ReactNode {
        if (this.model.isInit) {
            return (<></>);
        }
        return (
            <div style={{ width: '100%', padding: '64px' }}>
                <MonthlyVacationExportPaper />

                <Paper title="API key" desc="The API key can be used to access the registered timeoffs programatically.">
                    {this.model.apiKey && (
                        <>
                            <div style={{ marginBottom: '48px' }}>
                                {this.model.apiKey}
                            </div>
                            <Button color="secondary" onClick={this.handleRevokeApiKeyClicked}>Revoke</Button>
                        </>
                    )}
                    {!this.model.apiKey && (
                        <>
                            <div style={{ marginBottom: '48px' }}>
                                You dont't have any API key now. Generate it!
                            </div>
                            <Button variant="contained" color="default" onClick={this.handleGenerateApiKeyClicked}>Generate</Button>
                        </>
                    )}
                </Paper>
            </div>
        );
    }


}

export class Props {

}

export class ExportSceneFactory implements ISceneFactory {

    public create(historyItem: HistoryItem): React.ReactNode {
        return (
            <ExportScene />
        );
    }

}